<script setup lang="ts">
import { computed, ref } from 'vue';

import Button from '@/components/ui/button/Button.vue';
import Input from '@/components/ui/input/Input.vue';
import { reIndexDatasourceErrorFiles } from '@/services/data_source';
import { useTenantStore } from '@/stores/tenant';

const tenantStore = useTenantStore();

const tenantId = computed(() => {
    return tenantStore.tenantId;
});

const dataSourceId = ref<string>();

const handleRetryIndexing = async () => {
    if (tenantId.value && dataSourceId.value) {
        const dataSourceIdNumber = Number(dataSourceId.value);
        if (!isNaN(dataSourceIdNumber)) {
            try {
                reIndexDatasourceErrorFiles(dataSourceIdNumber, tenantId.value);
                console.log(dataSourceIdNumber);
            } catch (e) {
                console.log(e);
            } finally {
                dataSourceId.value = undefined;
            }
        } else {
            console.error('dataSourceId is not a valid number');
        }
    }
};
</script>

<template>
    <div class="flex flex-col gap-4">
        <h3 class="text-md font-medium">
            Retry indexing for files with Error Status
        </h3>
        <div class="flex gap-3 items-center max-w-64">
            <Input
                v-model="dataSourceId"
                placeholder="Data source id"
                class="placeholder:text-placeholder"
            />
            <Button class="shrink-0" size="sm" @click="handleRetryIndexing">
                Retry indexing
            </Button>
        </div>
    </div>
</template>
